import { Component, OnInit } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { CommonModule } from "@angular/common";
import { MatSelectModule } from "@angular/material/select";
import { FieldResource } from "../../core/modules/openapi";
import { Observable, of, switchMap } from "rxjs";

@Component({
  selector: "app-select",
  imports: [MatFormFieldModule, MatSelectModule, ReactiveFormsModule, CommonModule],
  template: `
    <div class="app-input" *ngIf="visible | async; let isVisible">
      <mat-form-field [formGroup]="group" floatLabel="always" class="full-width-field">
        <mat-label [innerHTML]="field.displayName"></mat-label>
        <mat-select placeholder="---None---" [formControlName]="field.name"
                    [multiple]="field.multiple" (selectionChange)="updateDetails($event)">
          <mat-option *ngFor="let item of field.possibleValues"
                      [value]="item.value">{{ item.name }}
          </mat-option>
        </mat-select>
        <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
          <mat-error
            *ngIf="group.controls[field.name].hasError(validation.name.toLowerCase())">{{ validation.message }}
          </mat-error>
        </ng-container>
      </mat-form-field>
    </div>
  `,
  standalone: true,
  styleUrls: ['./select.component.sass']
})
export class SelectComponent implements OnInit {
  field: FieldResource;
  group: FormGroup;
  detailsUrls: object[] = [];
  subject: Observable<string>;
  visible: Observable<boolean>;

  ngOnInit() {
    this.updateDetailsUrl(this.field.value);
    //this.field.possibleValues = this.orderPipe.transform(this.field.possibleValues, 'name', false, true);
    this.visible = this.subject.pipe(switchMap(x => of(this.isVisible(x))));
  }

  updateDetails($event: { value: any; }) {
    this.updateDetailsUrl($event.value);
  }

  updateDetailsUrl(newValue: string | object | undefined) {
    this.detailsUrls = [];
    if(newValue instanceof String && newValue.length > 0 && this.field?.possibleValues) {
      if(this.field.multiple) {
        for(let ev of newValue) {
          let option = this.field.possibleValues.find(function(element:any) {
            return element["value" as keyof typeof element] === ev;
              });
          if(option) {
            this.detailsUrls.push(option);
          }
        }
      } else {
        let option = this.field.possibleValues.find(function(element:any) {
          return element["value" as keyof typeof element] === newValue;
        });
        if(option) {
          this.detailsUrls.push(option);
        }
      }
    }
  }

  isVisible(value:string)
  {
    if(this.field.visibilityGroup && this.field.visibilityGroup === value) {
      if(this.field.enabled) {
        this.group.controls[this.field.name]?.enable();
      }
      return true;
    } else if(!this.field.visibilityGroup) {
      if(this.field.enabled) {
        this.group.controls[this.field.name]?.enable();
      }
      return true;
    } else {
      // // if(this.field.enabled) {
      //   this.group.controls[this.field.name]?.enable();
      // } else {
        this.group.controls[this.field.name]?.disable();
      // }
      return false;
    }
  }
}
